import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HeadingType } from 'src/app/shared/components/heading/heading.types';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-email-call-contact',
  templateUrl: './email-call-contact.component.html',
  styleUrls: ['./email-call-contact.component.scss'],
})
export class EmailCallContactComponent {
  // Heading message to display on top of the tile
  @Input() heading;

  @Input() headingType: HeadingType = 'h3';

  // Update parent component about click
  @Output() handleClick = new EventEmitter();

  constructor(private utilityService: UtilityService) {}

  /**
   * Mail or call for support.
   *
   * @param link - Link for support.
   */
  mailOrCall(link) {
    this.utilityService.openExternalLink(link);
    this.handleClick.emit(link);
  }
}
